import { createSelector } from 'reselect';
import {
  getArmyListUnit,
  getArmyListUnitState,
} from '../make/unit/edit/selector/editSelector';
import { ArmyListUnitView } from './ArmyListUnitView';
import { UnitCaracType } from '@Models';

export const armyListUnitPresenter = createSelector(
  [getArmyListUnitState, getArmyListUnit],
  (armyListUnitState, armyListUnit): ArmyListUnitView => {
    return new ArmyListUnitView({
      id: armyListUnitState.id!,
      name: armyListUnit?.name ?? '',
      points: armyListUnit?.points ?? 0,
      showV3: armyListUnit?.carac?.type === UnitCaracType.V3,
      showV2: armyListUnit?.carac?.type === UnitCaracType.V2,
      showV1: armyListUnit?.carac?.type === UnitCaracType.V1,
      item: armyListUnit,
    });
  },
);
